import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAtqqBVTcXgVypUxeNYQ2JfbcxHWicIPFk",
    authDomain: "civic-sun-db.firebaseapp.com",
    projectId: "civic-sun-db",
    storageBucket: "civic-sun-db.firebasestorage.app",
    messagingSenderId: "125957909133",
    appId: "1:125957909133:web:15bbc414f066803ed4d0c4"
};

const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
export default firebaseApp;
